/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10.339 16.552a6.449 6.449 0 0 0 4.187-1.94.417.417 0 0 1 .296-.124h3.022a4.156 4.156 0 1 0 0-8.311h-.883a.417.417 0 0 1-.416-.417v-.417a.833.833 0 0 0-.834-.833H4.077a.833.833 0 0 0-.833.833v4.574a6.65 6.65 0 0 0 7.095 6.635Zm7.505-8.713a2.493 2.493 0 0 1 0 4.987h-1.4a.416.416 0 0 1-.386-.568c.322-.818.488-1.69.488-2.569V8.254c0-.23.186-.416.416-.416l.882.001ZM2.833 17.813h18.284a.833.833 0 0 1 0 1.667H2.833a.833.833 0 1 1 0-1.667Z"
})), "0 0 24 24", "Coffee");